<template>
  <div>
<base-background image="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1348&q=80" inner-class="bg-primary-dark-op">
      <div  class="content content-narrow content-full">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mt-5 mb-2 text-center text-sm-left">
          <div class="flex-sm-fill">
            <h1 class="font-w600 text-white mb-0">{{producto.nombre}}</h1>
           
         
            
          </div>

          <div class="mt-3 mt-sm-0 ml-sm-3">
              <router-link 
              :to="{name: 'Productosadmin'}">
            <b-button variant="primary" class="px-4 py-2" href="javascript:void(0)" v-click-ripple>
              REGRESAR
            </b-button>
               </router-link>
          </div>
        </div>
      </div>
    </base-background>

    <div class="content" >
     <v-row v-if="spin == 2"
        class="fill-height"
        align-content="center"
  
      >
        <v-col
          class="subtitle-1 text-center"
          cols="12"
        >
        <v-progress-circular
      :size="70"
      :width="7"
      color="purple"
      indeterminate
    ></v-progress-circular>
        </v-col>
     
      </v-row>
<div style="background-color:white; padding: 10px; margin-bottom:25px; border-radius:15px; border-color:black !important; border-width: 1px;
  border-style: solid;"> 

   <b-form v-show="spin == 1" @submit.prevent="addProduct" @reset="onReset" enctype="multipart/form-data">
 

 <b-form-group id="input-group-1" label="Ficha tecnica" label-for="input-1">
 
             <input   required class="e-input" name='input' type="text"  v-model="enlace[0].tecnica"/>
     </b-form-group>
     <b-form-group id="input-group-2" label="Hoja de seguridad" label-for="input-2">
           <input  id="input-1" required class="e-input" name='input' type="text" v-model="enlace[0].seguridad"/>
     </b-form-group>


      <b-button type="submit" variant="primary" COLOR="WHITE">GUARDAR PRODUCTO</b-button>
      <b-button type="reset" style="margin-left:15px;" variant="danger">REINICIAR</b-button>
    </b-form>
  </div>
   
 
   </div>
  </div>
</template>

<style lang="scss">
// CKEditor Custom overrides
@import './src/assets/scss/vendor/ckeditor';
@import url(https://cdn.syncfusion.com/ej2/material.css);
// SimpleMDE + Custom overrides
@import '~simplemde/dist/simplemde.min.css';
@import './src/assets/scss/vendor/simplemde';
</style>

<script>
import Vue from "vue";
import { AutoCompletePlugin } from "@syncfusion/ej2-vue-dropdowns";
Vue.use(AutoCompletePlugin);
import {mapActions, mapState} from 'vuex'
import axios from 'axios'
// Vue SimpleMDE, for more info and examples you can check out https://github.com/F-loat/vue-simplemde
import VueSimplemde from 'vue-simplemde'

// CKEditor 5, for more info and examples you can check out https://ckeditor.com/ckeditor-5
import CKEditor from '@ckeditor/ckeditor5-vue'

// You can import one of the following CKEditor variation (only one at a time)
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
//import InlineEditor from '@ckeditor/ckeditor5-build-inline'
//import BalloonEditor from '@ckeditor/ckeditor5-build-balloon'
//import BalloonBlockEditor from '@ckeditor/ckeditor5-build-balloon-block'

export default {
  name:'Newtask',
 
  components: {

  },

  data () {
    return { 
          spin:1,
          categorias:[],
    divisiones:[],
    subcategorias:[],
    dataCategoria:{value:'categoria'},
    dataSubcategoria:{value:'subcategoria'},
    dataDivision:{value:'division'},
    imagenMiniatura: '',
      
     enlace:{
     
seguridad:'',
tecnica:'',
enlace:'',
     },
    producto:{    
    
          nombre: '',
          division: '',
          categoria: '',
          subcategoria:'',
          descripcion:'',
          notasadicionales:'',
          codigo:'',
          notas:'',
          image:null
          },
 
      id: this.$route.params.id,   
    
    
  
    }
  },
  
 
  methods: {
   addProduct(){
        this.spin = 2
        let formData = new FormData();
       console.log(this.enlace[0].seguridad)
        formData.append('seguridad',this.enlace[0].seguridad),
        formData.append('tecnica',this.enlace[0].tecnica),
    
      

        //axios.post('http://127.0.0.1:5050/productos/new', formData)
        axios.post('https://vicolors.com.mx/phpapi/productos/'+this.enlace[0].id+'/updatelink', formData)
        .then(response => {
            console.log(response.data);
             this.spin = 1;
            console.log(response.data.message);
                this.$swal('Éxito', 'Producto ha sido editado correctamente', 'success')
        })
},


 getclases(){
   
      let urlCat = '/productos/categorias';
      let urlSub = '/productos/subcategorias';
      let urlDiv = '/productos/divisiones';
      this.axios.get(urlCat)
      .then(res => {
       
      
        this.categorias=res.data
       
      })
      .catch(err => {
        console.error(err); 
      })
        this.axios.get(urlSub)
      .then(res => {
       
      
        this.subcategorias=res.data
       
      })
      .catch(err => {
        console.error(err); 
      })
         this.axios.get(urlDiv)
      .then(res => {
       
      
        this.divisiones=res.data
       
      })
      .catch(err => {
        console.error(err); 
      })
    },


 getproducto(){
   
      let url = '/productos/'+this.id;
      this.axios.get(url)
      .then(res => {
       
      
        this.producto=res.data
       
     
      })
      .catch(err => {
        console.error(err); 
      })
    },


 getenlace(){
   
      let url = '/enlace/'+this.id;
      this.axios.get(url)
      .then(res => {
       
      
        this.enlace=res.data
       console.log(this.enlace)
     
      })
      .catch(err => {
        console.error(err); 
      })
    },


 








      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.producto.nombre = '',
        this.producto.codigo = '',
        this.producto.descripcion = '',
        this.producto.division = '',
        this.producto.categoria = '',
        this.producto.subcategoria = '',
        this.producto.notas = '',
        this.producto.image = null,
        this.imagenMiniatura= ''
        this.imagen
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
  
     
  },
 computed: {
    
     imagen(){
         return this.imagenMiniatura;
     },
     
   
 },
 created() {
     
     this.getproducto()
     this.getclases()
     this.getenlace()
 },
 
}
</script>